import React, { useState, useEffect, useMemo } from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from "./components/Header";
import Hero from "./sections/Hero";
import Certifications from "./sections/Certifications";
import Skills from "./sections/Skills";
import Projects from "./sections/Projects";
import Writeups from "./sections/Writeups";
import Blog from "./sections/Blog";
import Contacts from "./sections/Contacts";
import Footer from "./sections/Footer";
import SebfxButton from "./components/SebfxButton";
import ProjectsPage from "./pages/ProjectsPage";
import { getTheme } from "./theme/theme";

export default function App() {
  const [showHeader, setShowHeader] = useState(true);
  const [mode, setMode] = useState("dark");

  useEffect(() => {
    let lastScrollY = window.scrollY;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY <= 50) setShowHeader(true);
      else if (currentScrollY > lastScrollY) setShowHeader(false);
      else setShowHeader(true);
      lastScrollY = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const theme = useMemo(() => {
    const generatedTheme = getTheme(mode);
    return generatedTheme || createTheme({ palette: { mode } });
  }, [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Box sx={{ bgcolor: "background.default", minHeight: "100vh", position: "relative" }}>
          {showHeader && <Header />}
          
          <Routes>
            {/* Main Portfolio Route */}
            <Route path="/" element={
              <>
                <Hero />
                <Box id="about"><Certifications /></Box>
                <Box id="skills"><Skills /></Box>
                 <Box id="projects"><Projects /></Box>
                  <Box id="blog"><Blog /></Box>
                <Writeups />
                <Contacts />
                <Footer />
              </>
            } />
            
            {/* Dedicated Projects Hub Route */}
            <Route path="/projects/:projectId" element={<ProjectsPage />} />
          </Routes>

          <SebfxButton />
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  );
}

